
export default {
    // props: {
    //     minDate: Number,
    //     maxDate: Number,
    //     defaultTime: String,
    // },

    computed: {
        dateModel: {
            get() {
                return !this.model ? null : dayjs(this.model).startOf('day').toDate();
            },
            set(value) {
                const t = this.model ? dayjs(this.model) : dayjs(this.defaultTime || '0:00', 'H:mm').year(0);
                const d = dayjs(value);

                if (!t.isSame(d, 'day')) {
                    this.model = !value ? null : this.fromDateTime(d, t);

                    this.$nextTick(() => {
                        if (this.timeTooLow) {
                            this.timeModel = this.minTime;
                        } else if (this.timeTooHigh) {
                            this.timeModel = this.maxTime;
                        }
                    });
                }
            },
        },
        timeModel: {
            get() {
                return !this.model ? (this.defaultTime || '0:00') : dayjs(this.model).format($.timeFormat);
            },
            set(value) {
                const d = dayjs(this.model);
                const t = dayjs(value, $.timeFormat);

                this.model = !this.model ? null : this.fromDateTime(d, t);
            },
        },
        minTime() {
            return (this.minDate && dayjs(this.minDate).isSame(this.model, 'day')) ? dayjs(this.minDate).format($.timeFormat) : undefined;
        },
        maxTime() {
            return (this.maxDate && dayjs(this.maxDate).isSame(this.model, 'day')) ? dayjs(this.maxDate).format($.timeFormat) : undefined;
        },
        timeTooLow() {
            return this.minTime && this.timeModel.padStart(5, '0') < this.minTime;
        },
        timeTooHigh() {
            return this.maxTime && this.timeModel.padStart(5, '0') > this.maxTime;
        },
        dateProps() {
            return {
                'min-date': this.minDate && new Date(this.minDate),
                'max-date': this.maxDate && new Date(this.maxDate),
            };
        },
        timeProps() {
            return {
                minTime: this.minTime,
                maxTime: this.maxTime,
                defaultTime: this.defaultTime,
            };
        },
    },

    methods: {
        fromDateTime(d, t) {
            return t.year(d.year()).month(d.month()).date(d.date()).valueOf();
        },
    },
};
